<template>
  <div>
    <div class="d-flex flex-column justify-center align-center"
         v-if="this.loadingStatus"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <div class="mt-4">bitte warten</div>
    </div>
    <v-alert
      v-if="this.errors[0]"
      colored-border
      type="error"
      elevation="0"
      dense
    >
      Entschuldigung: Es ist ein Fehler aufgetreten.
    </v-alert>
    <v-container fluid v-show="showThanks">
      <v-row>
        <v-col cols="12">
          <h2 class="text-h4"><b>Vielen Dank</b></h2>
          <p>Ihre Anfrage wurde übermittelt.</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-left">
          <v-btn
            @click="reset"
            color="secondary"
            outlined
            depressed
          >Formular erneut ausfüllen</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-stepper
      v-if="!loadingStatus && !showThanks"
      class="dehn-v-stepper"
      non-linear
      v-model="currentStep"
    >

      <v-stepper-header>
        <v-stepper-step
          editable
          :complete="currentStep > 1"
          edit-icon="$complete"
          step="1">
          Planung</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          editable
          :rules="[() => validation.step2.valid]"
          :complete="currentStep > 2"
          edit-icon="$complete"
          step="2">
          Gebäudeart / -nutzung
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          editable
          :complete="currentStep > 3"
          @click="$refs.stepForm2.validate()"
          edit-icon="$complete"
          step="3">
          Planungsgrundlagen</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          editable
          :rules="[() => validation.step4.valid]"
          :complete="currentStep > 4"
          edit-icon="$complete"
          step="4">
          Projekt- / Kundendaten</v-stepper-step>
      </v-stepper-header>

      <v-container
        v-if="currentStep == '0'"
        fluid
        class="intro dehn--module--text-only-and-or-headline__h1"
      >
        <v-row>
          <v-col cols="12" md="9" class="text">
            <p class="mb-0">
              DEHN Engineering Know how für Ihre Projekte<br><br>
              Lassen Sie sich jetzt ein Planungsangebot für Ihr maßgeschneidertes Schutzkonzept erstellen.<br><br>
              Das Planungsangebot für Ihr Bauvorhaben wird umso genauer, je detaillierter Ihre Angaben in diesem Form sind.
              Unterlagen zum Planungsobjekt können Sie im Verlauf ganz einfach hochladen.<br><br>
              Besonders praktisch: Sie können an jeder Stelle im Formular pausieren und später fortfahren –
              die eingetragenen Daten bleiben erhalten.<br><br>
              Bei Fragen wenden Sie sich gerne an<br>
              <a href="mailto:dehnconcept@dehn.de" style="text-decoration: underline;">dehnconcept@dehn.de</a><br>
              Tel. +49 9181 906-1600
            </p>
          </v-col>
        </v-row>
      </v-container>

      <v-stepper-items>
        <v-stepper-content step="1" class="step1">
          <v-form
            ref="stepForm1"
          >
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <h3>Welche Planungsleistungen benötigen Sie für Ihr Projekt?</h3>
                  <p>(Bitte beachten Sie, jede Leistung ist kostenpflichtig!)</p>
                  <v-checkbox
                    v-model="formData.planung_aussen_innen_blitzschutz"
                    label="Blitzschutzkonzept"
                    value="BLITZSCHUTZKONZEPT"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Blitzschutzkonzept (in 3D)
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-blitzschutzkonzept></tooltip-blitzschutzkonzept>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-blitzschutzkonzept
                    class="dehn--leistung-html"
                    v-show="formData.planung_aussen_innen_blitzschutz.includes('BLITZSCHUTZKONZEPT')"
                  >
                  </tooltip-blitzschutzkonzept>
                  <v-checkbox
                    v-model="formData.planung_erdung_blitzschutz"
                    label="Erdungskonzept für Blitzschutzsysteme"
                    value="ERDUNGSKONZEPT_BLITZSCHUTZSYSTEME"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Erdungskonzept für Blitzschutzsysteme
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-erdungskonzept-blitzschutzsysteme></tooltip-erdungskonzept-blitzschutzsysteme>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-erdungskonzept-blitzschutzsysteme
                    class="dehn--leistung-html"
                    v-show="formData.planung_erdung_blitzschutz.includes('ERDUNGSKONZEPT_BLITZSCHUTZSYSTEME')"
                  ></tooltip-erdungskonzept-blitzschutzsysteme>
                  <v-checkbox
                    v-model="formData.planung_aussen_innen_blitzschutz"
                    label="Überspannungsschutzkonzept"
                    value="UEBERSPANNUNGSSCHUTZKONZEPT"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Überspannungsschutzkonzept
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-ueberspannungsschutzkonzept></tooltip-ueberspannungsschutzkonzept>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-ueberspannungsschutzkonzept
                    class="dehn--leistung-html"
                    v-show="formData.planung_aussen_innen_blitzschutz.includes('UEBERSPANNUNGSSCHUTZKONZEPT')"
                  ></tooltip-ueberspannungsschutzkonzept>
                  <v-checkbox
                    v-model="formData.planung_aussen_innen_blitzschutz"
                    label="Kostenschätzung für Blitzschutz- und Erdungsmaterial (enthält keine Stückliste)"
                    value="BUDGETPLANUNG"
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Kostenschätzung für Blitzschutz- und Erdungsmaterial (enthält keine Stückliste)
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-budgetplanung></tooltip-budgetplanung>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-budgetplanung
                    class="dehn--leistung-html"
                    style="margin-top: -0.5rem;margin-bottom: 1rem"
                    v-show="formData.planung_aussen_innen_blitzschutz.includes('BUDGETPLANUNG')"
                  ></tooltip-budgetplanung>
                  <p>Optional</p>
                  <v-checkbox
                    v-model="formData.planung_sonstiges"
                    label="Planungsabschlussgespräch"
                    value="PLANUNGSABSCHLUSSGESPRAECH"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Planungsabschlussgespräch
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-planungsabschlussgespraech></tooltip-planungsabschlussgespraech>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-planungsabschlussgespraech
                    class="dehn--leistung-html"
                    v-show="formData.planung_sonstiges.includes('PLANUNGSABSCHLUSSGESPRAECH')"
                  ></tooltip-planungsabschlussgespraech>

                  <h3 class="mt-12">
                    <b>Weitere Leistungen im Bereich Blitzschutz:</b>
                  </h3>
                  <v-checkbox
                    v-model="formData.planung_aussen_innen_blitzschutz"
                    label="Risikoanalyse"
                    value="RISIKOANALYSE"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>Risikoanalyse
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-risikoanalyse></tooltip-risikoanalyse>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-risikoanalyse
                    class="dehn--leistung-html"
                    v-show="formData.planung_aussen_innen_blitzschutz.includes('RISIKOANALYSE')"
                  ></tooltip-risikoanalyse>
                  <v-checkbox
                    v-model="formData.planung_aussen_innen_blitzschutz"
                    label="Trennungsabstandsberechnung für bestehende Blitzschutzsysteme"
                    value="TRENNUNGSABSTANDSBERECHNUNG"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Trennungsabstandsberechnung für bestehende Blitzschutzsysteme
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-trennungsabstandsberechnung></tooltip-trennungsabstandsberechnung>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-trennungsabstandsberechnung
                    class="dehn--leistung-html"
                    v-show="formData.planung_aussen_innen_blitzschutz.includes('TRENNUNGSABSTANDSBERECHNUNG')"
                  ></tooltip-trennungsabstandsberechnung>
                  <v-checkbox
                    v-model="formData.planung_aussen_innen_blitzschutz"
                    label="3D-Laserscanning zur Aufnahme der maßstabsgerechten Darstellung des aktuellen Baubestandes"
                    value="LASERSCANNING"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            3D-Laserscanning zur Aufnahme der maßstabsgerechten Darstellung des aktuellen Baubestandes
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip3-d-laserscanning></tooltip3-d-laserscanning>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip3-d-laserscanning
                    class="dehn--leistung-html"
                    v-show="formData.planung_aussen_innen_blitzschutz.includes('LASERSCANNING')"
                  ></tooltip3-d-laserscanning>
                  <v-checkbox
                    v-model="formData.planung_aussen_innen_blitzschutz"
                    label="Zeichnungserstellung / Modellerstellung zur maßstabsgerechten Darstellung des aktuellen Baubestandes"
                    value="ZEICHNUNGSERSTELLUNG"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Zeichnungserstellung / Modellerstellung zur maßstabsgerechten Darstellung des aktuellen Baubestandes
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-zeichnungserstellung></tooltip-zeichnungserstellung>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-zeichnungserstellung
                    class="dehn--leistung-html"
                    v-show="formData.planung_aussen_innen_blitzschutz.includes('ZEICHNUNGSERSTELLUNG')"
                  ></tooltip-zeichnungserstellung>

                  <v-checkbox
                    v-model="formData.planung_aussen_innen_blitzschutz"
                    label="Schutzraumüberprüfung von bestehenden Blitzschutzsystemen (in 3D)"
                    value="SCHUTZRAUMUEBERPRUEFUNG"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Schutzraumüberprüfung von bestehenden Blitzschutzsystemen (in 3D)
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-schutzraum></tooltip-schutzraum>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-schutzraum
                    class="dehn--leistung-html"
                    v-show="formData.planung_aussen_innen_blitzschutz.includes('SCHUTZRAUMUEBERPRUEFUNG')"
                  ></tooltip-schutzraum>
                  <v-checkbox
                    v-model="formData.planung_sonstiges"
                    label="Abnahme Blitzschutz"
                    value="ABNAHME_BLITZSCHUTZ"
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Abnahme Blitzschutz
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-abnahme-blitzschutz></tooltip-abnahme-blitzschutz>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-abnahme-blitzschutz
                    class="dehn--leistung-html"
                    v-show="formData.planung_sonstiges.includes('ABNAHME_BLITZSCHUTZ')"
                  ></tooltip-abnahme-blitzschutz>

                  <h3 class="mt-12">
                    <b>Weitere Leistungen im Bereich Erdung:</b>
                  </h3>

                  <v-checkbox
                    v-model="formData.planung_erdung_blitzschutz"
                    label="Dimensionierung Erdungsanlage an Trafostationen / Schaltanlagen"
                    value="ERDUNGS_DIMENSIONIERUNG_TRAFO"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Dimensionierung Erdungsanlage an Trafostationen / Schaltanlagen
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-dimensionierung-erdungsanlage></tooltip-dimensionierung-erdungsanlage>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-dimensionierung-erdungsanlage
                    class="dehn--leistung-html"
                    v-show="formData.planung_erdung_blitzschutz.includes('ERDUNGS_DIMENSIONIERUNG_TRAFO')"
                  ></tooltip-dimensionierung-erdungsanlage>
                  <v-checkbox
                    v-model="formData.planung_trafostationen"
                    label="Querschnittsberechnung von Erdleitern für Trafostationen"
                    value="QUERSCHNITTS_BERECHNUNG"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Querschnittsberechnung von Erdleitern für Trafostationen
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-querschnittsberechnung></tooltip-querschnittsberechnung>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-querschnittsberechnung
                    class="dehn--leistung-html"
                    v-show="formData.planung_trafostationen.includes('QUERSCHNITTS_BERECHNUNG')"
                  ></tooltip-querschnittsberechnung>
                  <v-checkbox
                    v-model="formData.planung_trafostationen"
                    label="Erdungssimulation von Schritt- und Berührungspannung bei Blitzbeeinflussung an Trafostationen"
                    value="ERDUNGS_SIMULATION_BLITZ_TRAFO"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Erdungssimulation von Schritt- und Berührungspannung bei Blitzbeeinflussung
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-erdungssimulation-blitz-trafo></tooltip-erdungssimulation-blitz-trafo>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-erdungssimulation-blitz-trafo
                    class="dehn--leistung-html"
                    v-show="formData.planung_trafostationen.includes('ERDUNGS_SIMULATION_BLITZ_TRAFO')"
                  ></tooltip-erdungssimulation-blitz-trafo>
                  <v-checkbox
                    v-model="formData.planung_trafostationen"
                    label="Erdungssimulationen von Schritt- und Berührspannung für Kurzschlussstrombeeinflussung 50 Hz (Trafoanlagen, Schaltanlagen, etc.)"
                    value="ERDUNGS_SIMULATION_KURZSCHLUSS"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            Erdungssimulationen von Schritt- und Berührspannung für Kurzschlussstrombeeinflussung 50 Hz (Trafoanlagen, Schaltanlagen, etc.)
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        <div class="dehn--tooltip-html">
                          <tooltip-erdungssimulationen-kurzschluss></tooltip-erdungssimulationen-kurzschluss>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <tooltip-erdungssimulationen-kurzschluss
                    class="dehn--leistung-html"
                    v-show="formData.planung_trafostationen.includes('ERDUNGS_SIMULATION_KURZSCHLUSS')"
                  ></tooltip-erdungssimulationen-kurzschluss>

                </v-col>
                <v-col>
                  <a href="https://www.dehn.de/de/leistungsbeschreibungen-dehnconcept-uebersicht"
                     target="_blank"
                     style="text-decoration: underline;"
                  >
                    <h3>Welches sind die passenden Leistungen für mein Projekt? Mehr Info auf der Website.<v-icon class="pl-2">mdi-launch</v-icon></h3>
                  </a>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2" class="step2">
          <v-form
            v-model="validation.step2.valid"
            lazy-validation
            ref="stepForm2"
          >
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="formData.projekt_name"
                  >
                    <template #label>
                      <strong>Projektname</strong>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h3><b>Ihre Branche</b></h3>
                  <v-select
                    v-model="formData.gebauede_branche"
                    item-text="name"
                    item-value="id"
                    :items="selectData.gebauede_branche"
                    label="Bitte auswählen"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row  v-if="formData.gebauede_branche.includes('SONSTIGES')">
                <v-col cols="12">
                  <h3>Andere Branche</h3>
                  <v-textarea
                    v-model="formData.gebauede_branche_andere"
                    outlined
                    :rules="[v => v.length <= 1000 || 'Maximal 1000 Zeichen']"
                    counter
                    dense
                  ></v-textarea>
                </v-col>
              </v-row>

              <template v-if="!onlyEarthingStuffSelected">
                <v-row>
                  <v-col md="4">
                    <h3>
                      <b>Örtliche Gegebenheiten </b>
                      <v-tooltip
                        right
                        max-width="400"
                        open-on-click
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="primary"
                            dark
                            dense
                            middle
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>
                          Wieso werden die Daten für die Örtlichen Gegebenheiten benötigt ?
                          Diese Angaben sind die Grundlage für eine Vielzahl von Entscheidungen bei der spezifischen Produktauswahl.
                          Welches Material ? Welche Materialstärke? Welcher Wetterschutz ? etc.
                          </span>
                      </v-tooltip>
                    </h3>
                    <v-text-field
                      v-model="formData.gebauede_ortgegeb_gebauedehoehe"
                      label="m Gebäudehöhe über dem Erdboden"

                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="4">
                    <v-text-field
                      v-model="formData.gebauede_ortgegeb_gebauedlage"
                      label="m Gebäudelage über NN"
                      dense
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="4">
                    <v-text-field
                      v-model="formData.gebauede_ortgegeb_boengeschwindigkeit"
                      label="km/h Böengeschwindigkeit"
                      dense
                      hide-details="auto"
                    >
                      <template v-slot:append>
                        <v-dialog
                          v-model="dialogBoen"
                          max-width="800px"
                          scrollable
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <v-card>
                            <v-toolbar
                              flat
                              dark
                              color="background"
                            >
                              <v-toolbar-title>Windzonen als Grundparameter</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-toolbar-items>
                                <v-btn
                                  @click="dialogBoen = false"
                                  icon dark
                                  aria-label="Close">
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                              </v-toolbar-items>
                            </v-toolbar>
                            <v-card-text class="mt-6 mb-0">
                              <v-container>
                                <v-row>
                                  <v-col col="12">
                                    <p>Deutschland ist in vier Windzonen mit unterschiedlichen Grundwindgeschwindigkeiten
                                      unterteilt. Die Grundwindgeschwindigkeiten sind wie folgt untergliedert:
                                    </p>
                                    <p>Grundgeschwindigkeit:</p>
                                    <ul>
                                      <li>22,5 m/s (Windzone 1)</li>
                                      <li>25,0 m/s&nbsp;(Windzone 2)</li>
                                      <li>27,5 m/s&nbsp;(Windzone 3)</li>
                                      <li>30,0 m/s&nbsp;(Windzone 4)</li>
                                    </ul>
                                  </v-col>
                                  <v-col col="12">
                                    <v-img
                                      lazy-src="https://www.dehn.de/sites/default/files/styles/max_width_160/public/media/images/2018-06/dsfgh.jpg"
                                      src="https://www.dehn.de/sites/default/files/styles/max_width_1120/public/media/images/2018-06/dsfgh.jpg"
                                    ></v-img>
                                  </v-col>
                                </v-row>
                              </v-container>

                            </v-card-text>
                          </v-card>
                        </v-dialog>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="4">
                    <v-text-field
                      v-model="formData.gebauede_ortgegeb_windzone"
                      label="Windzone"
                      dense
                      hide-details="auto"
                    >
                      <template v-slot:append>
                        <v-dialog
                          v-model="dialogWindzone"
                          max-width="600px"
                          scrollable
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <v-card>
                            <v-toolbar
                              flat
                              dark
                              color="background"
                            >
                              <v-toolbar-title>Windzonenberechnung</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-toolbar-items>
                                <v-btn
                                  @click="dialogWindzone = false"
                                  icon dark
                                  aria-label="Close">
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                              </v-toolbar-items>
                            </v-toolbar>
                            <v-card-text>
                              <iframe src="https://www.dehn.de/windzonen/?zip="
                                      style="width: 1px; min-width: 100%; margin-bottom: 2rem; height: 300px; overflow: hidden;"
                                      scrolling="no" marginheight="0" marginwidth="0" frameborder="0">
                              </iframe>
                            </v-card-text>
                          </v-card>
                        </v-dialog>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="4">
                    <v-text-field
                      v-model="formData.gebauede_ortgegeb_gelaendekategorie"
                      label="Geländekategorie"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>

              <v-row>
                <v-col cols="12">
                  <h3><b>Gebäudestruktur / Anlagenstruktur</b></h3>
                </v-col>
              </v-row>
              <v-row>
                <div class="d-flex flex-column flex-sm-row align-sm-center pa-3">
                  <div style="width:150px;">
                    Art des Gebäudes:
                  </div>
                  <v-checkbox
                    v-model="formData.gebauede_struktur_art"
                    label="Neubau"
                    value="NEUBAU"
                    hide-details
                    class="shrink mr-2 mt-0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.gebauede_struktur_art"
                    label="Bestandsbau"
                    value="BESTANDSBAU"
                    hide-details
                    class="shrink mr-2 mt-0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.gebauede_struktur_art"
                    label="Denkmalschutz"
                    value="DENKMALSCHUTZ"
                    hide-details
                    class="shrink mr-2 mt-0"
                  ></v-checkbox>
                </div>
              </v-row>
              <template v-if="!onlyEarthingStuffSelected">
                <v-row>
                  <div class="d-flex flex-column flex-sm-row align-sm-center pa-3">
                    <div style="width:150px;">
                      Bedachung:
                    </div>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_bedachung"
                      label="Ziegeldach"
                      value="ZIEGELDACH"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_bedachung"
                      label="Blechdach"
                      value="BLECHDACH"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_bedachung"
                      label="Foliendach"
                      value="FOLIENDACH"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_bedachung"
                      label="andere"
                      value="ANDERE"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                  </div>
                </v-row>
                <v-row>
                  <div class="d-flex flex-column flex-sm-row align-sm-center pa-3">
                    <div style="width:150px;">
                      Gebäude&shy;konstruktion:
                    </div>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_konstruktion"
                      label="Stahlbeton"
                      value="STAHLBETON"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_konstruktion"
                      label="Stahlskelett"
                      value="STAHLSKELETT"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_konstruktion"
                      label="Mauerwerk"
                      value="MAUERWERK"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_konstruktion"
                      label="andere"
                      value="ANDERE"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                  </div>
                </v-row>
                <v-row>
                  <div class="d-flex flex-column flex-sm-row align-sm-center pa-3">
                    <div style="width:150px;">
                      Fassade:
                    </div>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_fassade"
                      label="Isoliert"
                      value="ISOLIERT"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_fassade"
                      label="nicht isoliert"
                      value="NICHT_ISOLIERT"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_fassade"
                      label="Metall"
                      value="METALL"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="formData.gebauede_struktur_fassade"
                      label="andere"
                      value="ANDERE"
                      hide-details
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                  </div>
                </v-row>
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      v-model="formData.gebauede_struktur_ausfuehrung_dach"
                      dense
                    >
                      <template v-slot:prepend>
                        <span style="display: inline-block;width:100px">Ausführung Dach</span>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </template>

              <template v-if="!onlyEarthingStuffSelected">
                <v-row>
                  <v-col cols="12">
                    <h3><b>Sind Ex-Zonen vorhanden?</b></h3>
                    <v-radio-group
                      v-model="formData.gebauede_ex_zonen"
                      hide-details
                    >
                      <v-radio
                        label="Ja"
                        value="TRUE"
                      ></v-radio>
                      <v-radio
                        label="Nein"
                        value="FALSE"
                      ></v-radio>
                    </v-radio-group>
                    <div v-if="formData.gebauede_ex_zonen.includes('TRUE')">
                      <small>Die entsprechenden Dokumente können Sie im weiteren Verlauf hochladen.</small>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <h3>
                      <b>Blitzschutzklasse </b>
                      <v-tooltip
                        right
                        max-width="400"
                        open-on-click
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="primary"
                            dark
                            dense
                            middle
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>
                      Die Blitzschutzklasse ist verpflichtend, sie ergibt sich aus der Risikoanalyse nach
                        DIN EN 62305-2 oder aus der Richtlinie VdS 2012.
                      </span>
                      </v-tooltip>
                    </h3>
                    <v-radio-group
                      v-model="formData.gebauede_blitzschutzklasse"
                      hide-details
                    >
                      <v-radio
                        label="LPL I"
                        value="I"
                      ></v-radio>
                      <v-radio
                        label="LPL II"
                        value="II"
                      ></v-radio>
                      <v-radio
                        label="LPL III"
                        value="III"
                      ></v-radio>
                      <v-radio
                        label="LPL IV"
                        value="IV"
                      ></v-radio>
                      <v-radio
                        label="Risikoanalyse erstellen"
                        value="risikoanalyse"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <h3>
                      <b>Wünschen Sie einen Vor-Ort-Termin ? </b>
                      <v-tooltip
                        right
                        max-width="400"
                        open-on-click
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="primary"
                            dark
                            dense
                            middle
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>
                          In diesem Termin nehmen wir die Gegebenheiten in Augenschein und geben Ihnen Hinweise, wie die Umsetzung des Schutzkonzeptes erfolgen kann.
                        </span>
                      </v-tooltip>
                    </h3>
                    <v-radio-group
                      v-model="formData.vor_ort_termin"
                      hide-details
                    >
                      <v-radio
                        label="Ja"
                        value="TRUE"
                      ></v-radio>
                      <v-radio
                        label="Nein"
                        value="FALSE"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </template>

              <v-row>
                <v-col cols="12">
                  <h3><b>Spezifische Infos zum Objekt:</b></h3>
                  <v-textarea
                    v-model="formData.gebauede_infos"
                    label="z.B. Wohngebäude, Industrieanlage, Heizkraftwerk, ... Gibt es Besonderheiten bei diesem Projekt?"
                    :rules="[v => v.length <= 1000 || 'Maximal 1000 Zeichen']"
                    counter
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>

            </v-container>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="3" class="step3">
          <v-form
            ref="stepForm3"
          >
            <v-container fluid>
              <!-- Angaben zur Budgetplanung -->
              <v-row v-if="formData.planung_aussen_innen_blitzschutz.includes('BUDGETPLANUNG')" class="angaben">
                <v-col cols="12">
                  <h2 class="text-h4">
                    <b>Angaben zur Budgetplanung</b>
                  </h2>
                </v-col>
                <v-col cols="12">
                  <h3 class="text-h5">
                    <b>Art des Blitzschutzsystems</b>
                  </h3>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Getrenntes Blitzschutzsystem
                  </h3>
                  <v-checkbox
                    v-model="formData.angaben_budget_getrenntes_blitzschutzsystem"
                    label="HVI-System"
                    value="HVI"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_budget_getrenntes_blitzschutzsystem"
                    label="Telemasten"
                    value="TELEMAST"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Konventionelles Blitzschutzsystem
                  </h3>
                  <v-checkbox
                    v-model="formData.angaben_budget_konventionelles_blitzschutzsystem"
                    label="Maschensystem"
                    value="MASCHENSYSTEM"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_budget_konventionelles_blitzschutzsystem"
                    label="Verbundenes System"
                    value="VERBUNDENES_SYSTEM"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>Verbundenes System
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        z.B. Industrieanlage
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_budget_konventionelles_blitzschutzsystem"
                    label="Vorschlag von DEHN"
                    value="DEHN"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>Vorschlag von DEHN
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        Welche Art von Blitzschutz wird benötigt? DEHN empfiehlt die technisch und wirtschaftlich optimierte Lösung für Ihr Projekt.
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <!-- Angaben Blitzschutzkonzept -->
              <v-row v-if="formData.planung_aussen_innen_blitzschutz.includes('BLITZSCHUTZKONZEPT')" class="angaben">
                <v-col cols="12">
                  <h2 class="text-h4">
                    <b>Angaben Blitzschutz </b>
                    <v-tooltip
                      right
                      max-width="400"
                      open-on-click
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          dark
                          dense
                          middle
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                         Das Blitzschutzkonzept erfolgt nach DIN EN 62305-3, IEC 62305-3.
                      </span>
                    </v-tooltip>
                  </h2>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Getrenntes Blitzschutzsystem
                  </h3>
                  <v-checkbox
                    v-model="formData.angaben_blitzschutz_getrenntes_blitzschutzsystem"
                    label="HVI-System"
                    value="HVI"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_blitzschutz_getrenntes_blitzschutzsystem"
                    label="Telemasten"
                    value="TELEMAST"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Konventionelles Blitzschutzsystem
                  </h3>
                  <v-checkbox
                    v-model="formData.angaben_blitzschutz_konventionelles_blitzschutzsystem"
                    label="Maschensystem"
                    value="MASCHENSYSTEM"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_blitzschutz_konventionelles_blitzschutzsystem"
                    label="Verbundenes System"
                    value="VERBUNDENES_SYSTEM"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>Verbundenes System
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        z.B. Industrieanlage
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_blitzschutz_konventionelles_blitzschutzsystem"
                    label="Vorschlag von DEHN"
                    value="DEHN"
                    hide-details
                  >
                    <template v-slot:label>
                      <v-tooltip
                        right
                        max-width="400"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div>Vorschlag von DEHN
                            <v-icon
                              color="primary"
                              dark
                              dense
                              middle
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-information-outline
                            </v-icon>
                          </div>
                        </template>
                        Welche Art von Blitzschutz wird benötigt? DEHN empfiehlt die technisch optimale Lösung für Ihr Projekt.
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <!-- Angaben Überspannungsschutz -->
              <v-row v-if="formData.planung_aussen_innen_blitzschutz.includes('UEBERSPANNUNGSSCHUTZKONZEPT')" class="angaben">
                <v-col cols="12">
                  <h2 class="text-h4">
                    <b>Angaben Überspannungsschutz </b>
                    <v-tooltip
                      right
                      max-width="400"
                      open-on-click
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          dark
                          dense
                          middle
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                         Das Überspannungsschutzkonzept erfolgt nach DIN EN 62305-3, IEC 62305-3 oder DIN EN 62305-4, IEC 62305-4.
                        </span>
                    </v-tooltip>
                  </h2>
                  <h3 class="text-h5">
                    Netzsystem der Anlage
                  </h3>
                  <v-radio-group
                    v-model="formData.angaben_ueberspannungsschutz_netzsystem"
                    hide-details
                  >
                    <v-radio
                      label="TN-C System"
                      value="TN_C"
                    ></v-radio>
                    <v-radio
                      label="TN-S System"
                      value="TN_S"
                    ></v-radio>
                    <v-radio
                      label="TN-C-S System"
                      value="TN_C_S"
                    ></v-radio>
                    <v-radio
                      label="IT System"
                      value="IT"
                    ></v-radio>
                    <v-radio
                      label="TT System"
                      value="TT"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <h3 class="text-h5">
                    Einspeisesicherung / Vorsicherung
                  </h3>
                  <v-radio-group
                    v-model="formData.angaben_ueberspannungsschutz_einspeisesicherung"
                    hide-details
                  >
                    <v-radio
                      label="> 315 A"
                      value="G315"
                    ></v-radio>
                    <v-radio
                      label="> 125 A"
                      value="G125"
                    ></v-radio>
                    <v-radio
                      label="andere"
                      value="ANDERE"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Energietechnische Anlage
                  </h3>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_energietechnische_anlage"
                    label="PV - Anlagen"
                    value="PV"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_energietechnische_anlage"
                    label="Sicherheitsbeleuchtung"
                    value="BELEUCHTUNG"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_energietechnische_anlage"
                    label="Sonnenschutzsystem"
                    value="SONNENSCHUTZ"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_energietechnische_anlage"
                    label="Lüftungssysteme (RLT)"
                    value="LUEFTUNG"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_energietechnische_anlage"
                    label="Heizungssystem"
                    value="HEIZUNG"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">Andere Anlage – bitte kurz nennen</h3>
                  <v-textarea
                    v-model="formData.angaben_ueberspannungsschutz_sonstiges_anlagen"
                    outlined
                    :rules="[v => v.length <= 1000 || 'Maximal 1000 Zeichen']"
                    counter
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Informationstechnische Anlagen
                  </h3>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_informationstechnische_anlagen"
                    label="Akustische Anlage (ELA)"
                    value="ELA"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_informationstechnische_anlagen"
                    label="Brandmeldeanlage (BMA)"
                    value="BMA"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_informationstechnische_anlagen"
                    label="Telefon – Anlage (TK)"
                    value="TK"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_informationstechnische_anlagen"
                    label="Datennetzwerk (EDV)"
                    value="EDV"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_informationstechnische_anlagen"
                    label="BUS - System (EIB, KNX)"
                    value="EIB_KNX"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.angaben_ueberspannungsschutz_informationstechnische_anlagen"
                    label="Antennentechnik (BK)"
                    value="BK"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">Andere MSR-Anlage – bitte kurz nennen</h3>
                  <v-textarea
                    v-model="formData.angaben_ueberspannungsschutz_sonstige_msr"
                    outlined
                    :rules="[v => v.length <= 1000 || 'Maximal 1000 Zeichen']"
                    counter
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <p>
                    Hinweis: Um ein Angebot für ein Überspannungsschutzkonzept zu erstellen, benötigen wir von Ihnen
                  </p>
                  <ul>
                    <li>
                      Stromlaufpläne [Kabeltyp, z.B. NYM 5x2,2 für Starkstrom / YSTY 10x2x0,8 für Schwachstrom]
                    </li>
                    <li>
                      Verteilerpläne [Ort des Verteilers/Endgerätes z.B. Keller, Fassade außen, Zone 0A/0B/1/2/3]
                    </li>
                    <li>
                      Flussdiagramm [Leitungsl&#228;nge zwischen den einzelnen UV&#39;s &quot;&lt; 10 m oder &gt; 10 m&quot;]
                    </li>
                  </ul>

                </v-col>
              </v-row>
              <!-- Angaben Erdung -->
              <v-row v-if="formData.planung_erdung_blitzschutz.includes('ERDUNGSKONZEPT_BLITZSCHUTZSYSTEME')" class="angaben">
                <v-col cols="12">
                  <h2 class="text-h4">
                    <b>Angaben Erdung </b>
                    <v-tooltip
                      right
                      max-width="400"
                      open-on-click
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          dark
                          dense
                          middle
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        Das Erdungskonzept für Blitzschutzsysteme erfolgt nach DIN 18014
                      </span>
                    </v-tooltip>
                  </h2>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Erdungstyp
                  </h3>
                  <v-radio-group
                    v-model="formData.angaben_erdung_erdungsangaben"
                    hide-details
                  >
                    <v-radio
                      label="Erdung Typ A - Bestandsbauten"
                      value="TYP_A"
                    >
                      <template v-slot:label>
                        <v-tooltip
                          right
                          max-width="400"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <div>Erdung Typ A - Bestandsbauten
                              <v-icon
                                color="primary"
                                dark
                                dense
                                middle
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-information-outline
                              </v-icon>
                            </div>
                          </template>
                          Die Erdung erfolgt durch Tiefen- und Horizontalerdern
                        </v-tooltip>
                      </template>
                    </v-radio>
                    <v-radio
                      label="Erdung Typ B - Neubauten"
                      value="TYP_B"
                    >
                      <template v-slot:label>
                        <v-tooltip
                          right
                          max-width="400"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <div>Erdung Typ B - Neubauten
                              <v-icon
                                color="primary"
                                dark
                                dense
                                middle
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-information-outline
                              </v-icon>
                            </div>
                          </template>
                          Die Erdung erfolgt mit Ring- und Fundamenterdern nach DIN 18014
                        </v-tooltip>
                      </template>
                    </v-radio>
                    <v-radio
                      label="Einordnung durch DEHN"
                      value="DEHN"
                    >
                      <template v-slot:label>
                        <v-tooltip
                          right
                          max-width="400"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <div>Einordnung durch DEHN
                              <v-icon
                                color="primary"
                                dark
                                dense
                                middle
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-information-outline
                              </v-icon>
                            </div>
                          </template>
                          Welche Art von Blitzschutz wird benötigt? DEHN übernimmt die Auswahl des Erdungstyps.
                        </v-tooltip>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Erdfühligkeit
                  </h3>
                  <v-radio-group
                    v-model="formData.angaben_erdung_erdfuehligkeit"
                    hide-details
                  >
                    <v-radio
                      label="Ja"
                      value="TRUE"
                    ></v-radio>
                    <v-radio
                      label="Nein"
                      value="FALSE"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- Angaben Risikoanalyse-->
              <v-row v-if="formData.planung_aussen_innen_blitzschutz.includes('RISIKOANALYSE')" class="angaben">
                <v-col cols="12">
                  <h2 class="text-h4">
                    <b>Angaben zur Risikoanalyse</b>
                  </h2>
                </v-col>
                <v-col cols="12">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="formData.angaben_risiko_max_person_anzahl"
                          label=""
                        >
                          <template v-slot:prepend>
                            <span style="display: inline-block;">Maximal halten sich</span>
                          </template>
                          <template v-slot:append-outer>
                            <span style="display: inline-block;">Personen</span>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="formData.angaben_risiko_max_person_stunden"
                          label=""
                        >
                          <template v-slot:append-outer>
                            <span style="display: inline-block;">Stunden pro Jahr in dem Objekt auf</span>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="formData.angaben_risiko_versorgungsleitungen"
                    label="Welche elektrischen Versorgungsleitungen sind vorhanden?"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Brandlast
                    <v-tooltip
                      right
                      max-width="400"
                      open-on-click
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          dark
                          dense
                          middle
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        Brandschutzdokument, wenn vorhanden bitte hochladen
                      </span>
                    </v-tooltip>
                  </h3>
                  <v-radio-group
                    v-model="formData.angaben_risiko_brandlast"
                    hide-details
                  >
                    <v-radio
                      label="Hoch"
                      value="HOCH"
                    ></v-radio>
                    <v-radio
                      label="Mittel"
                      value="MITTEL"
                    ></v-radio>
                    <v-radio
                      label="Gering"
                      value="GERING"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Gebäude freistehend?
                  </h3>
                  <v-radio-group
                    v-model="formData.angaben_risiko_freistehend"
                    hide-details
                  >
                    <v-radio
                      label="Ja"
                      value="TRUE"
                    ></v-radio>
                    <v-radio
                      label="Nein"
                      value="FALSE"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- Angaben zur Schutzraumüberprüfung von bestehenden Blitzschutzsystemen -->
              <v-row
                v-if="formData.planung_aussen_innen_blitzschutz.includes('BUDGETPLANUNG') || formData.planung_aussen_innen_blitzschutz.includes('BLITZSCHUTZKONZEPT') || formData.planung_aussen_innen_blitzschutz.includes('UEBERSPANNUNGSSCHUTZKONZEPT') || formData.planung_aussen_innen_blitzschutz.includes('TRENNUNGSABSTANDSBERECHNUNG') || formData.planung_aussen_innen_blitzschutz.includes('SCHUTZRAUMUEBERPRUEFUNG')"
                class="angaben">
                <v-col cols="12">
                  <h2 class="text-h4">
                    <b>3D-Modell</b>
                  </h2>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <h3 class="text-h5">
                    Besitzen Sie ein 3D-Modell des Gebäudes, welches zur Planung herangezogen werden kann?
                  </h3>
                  <v-radio-group
                    v-model="formData.angaben_3dmodell"
                    hide-details
                  >
                    <v-radio
                      label="Ja"
                      value="TRUE"
                    ></v-radio>
                    <v-radio
                      label="Nein"
                      value="FALSE"
                    ></v-radio>
                  </v-radio-group>
                  <div v-if="formData.angaben_3dmodell.includes('TRUE')">
                    <small>Bitte senden Sie uns das 3D-Modell im Format .nwd, .dwg oder .ifc zu.</small>
                  </div>
                </v-col>
              </v-row>
              <!-- Upload Hints -->
              <v-row>
                <v-col cols="12" sm="6">
                  <div v-if="formData.planung_erdung_blitzschutz.includes('ERDUNGSKONZEPT_BLITZSCHUTZSYSTEME')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Erdung ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Lagepläne</small></li>
                      <li><small>Fundamentpläne</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_aussen_innen_blitzschutz.includes('UEBERSPANNUNGSSCHUTZKONZEPT')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Überspannungsschutz ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Zeichnungen (Dachaufsichten, Seitenansichten, Schnitte)</small></li>
                      <li><small>Stromlaufpläne (Kabeltyp, z.B. NYM 5 x 2,2 für Starkstrom oder YSTY 10 x 2 x 0,8 für Schwachstrom)</small></li>
                      <li><small>Verteilerpläne (Ort des Verteilers oder Endgerätes z.B. Keller, Fassade außen, Blitzschutzzone 0A, 0B, 1, 2, 3)</small></li>
                      <li><small>Flussdiagramm (Leitungslänge zw. den einzelnen Unterverteilungen &lt; oder &gt; 10 m?)</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_aussen_innen_blitzschutz.includes('SCHUTZRAUMUEBERPRUEFUNG')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Schutzraumprüfung ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Maßstabsgerechte Darstellung des Objektes</small></li>
                      <li><small>Fotos des Objektes</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_aussen_innen_blitzschutz.includes('RISIKOANALYSE')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Risikoanalyse ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Zeichnungen</small></li>
                      <li><small>(Dachaufsichten, Seitenansichten, Schnitte)</small></li>
                      <li><small>Kartenausschnitt (Handyfoto oder Screenshot) zur Lage des Objektes</small></li>
                      <li><small>Brandschutzdokumente</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_aussen_innen_blitzschutz.includes('TRENNUNGSABSTANDSBERECHNUNG')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Trennungsabstand ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Pläne der Blitzschutzanlage</small></li>
                      <li><small>Zeichnungen (Dachaufsichten, Seitenansichten, Schnitte)</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_erdung_blitzschutz.includes('ERDUNGS_SIMULATION_BLITZ') || formData.planung_trafostationen.includes('ERDUNGS_SIMULATION_BLITZ_TRAFO') || formData.planung_trafostationen.includes('ERDUNGS_SIMULATION_KURZSCHLUSS')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Erdungssimulation ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Fotos des Objekts</small></li>
                      <li><small>Erdungspläne</small></li>
                      <li><small>Lagepläne</small></li>
                      <li><small>geotechnischen Bericht des Standortes</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_aussen_innen_blitzschutz.includes('TRENNUNGSABSTANDSBERECHNUNG')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Trennungsabstand ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Pläne der Blitzschutzanlage</small></li>
                      <li><small>Zeichnungen (Dachaufsichten, Seitenansichten, Schnitte)</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_aussen_innen_blitzschutz.includes('BLITZSCHUTZKONZEPT')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Blitzschutz ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Lageplänge</small></li>
                      <li><small>Zeichnungen (Dachaufsichten, Seitenansichten, Schnitte)</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_aussen_innen_blitzschutz.includes('BUDGETPLANUNG')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Budgetplanung ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Lageplänge</small></li>
                      <li><small>Zeichnungen (Dachaufsichten, Seitenansichten, Schnitte)</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_aussen_innen_blitzschutz.includes('LASERSCANNING')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema 3D-Laserscanning ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Kartenausschnitt (Handyfoto oder Screenshot) zur Lage des Objektes</small></li>
                      <li><small>Zeichnungen, falls vorhanden (Dachaufsichten, Seitenansichten, Schnitte)</small></li>
                    </ul>
                  </div>
                  <div v-if="formData.planung_aussen_innen_blitzschutz.includes('ZEICHNUNGSERSTELLUNG')">
                    <small>
                      <b>Hinweis:</b><br>
                      Sie haben das Thema Zeichnungserstellung ausgewählt, bitte laden Sie nun folgende Dokumente hoch:
                      <br />
                    </small>
                    <ul>
                      <li><small>Kartenausschnitt (Handyfoto oder Screenshot) zur Lage des Objektes</small></li>
                      <li><small>Zeichnungen, falls vorhanden (Dachaufsichten, Seitenansichten, Schnitte)</small></li>
                    </ul>
                  </div>

                </v-col>

              </v-row>
              <!-- Upload Component -->
              <upload-files :project="project"></upload-files>
              <v-row>
                <v-col cols="12">
                  <h3 class="text-h5"><b>Besteht für die Dokumente in diesem Projekt eine Geheimhaltungsvereinbarung (NDA)?</b></h3>
                  <v-radio-group
                    v-model="formData.upload_nda"
                    hide-details
                  >
                    <v-radio
                      label="Ja"
                      value="TRUE"
                    ></v-radio>
                    <v-radio
                      label="Nein"
                      value="FALSE"
                    ></v-radio>
                  </v-radio-group>
                  <div v-if="formData.upload_nda.includes('TRUE')">
                    <small>
                      Wir senden Ihnen unser beidseitiges NDA zu.
                    </small>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="4" class="step4">
          <v-form
            v-model="validation.step4.valid"
            ref="stepForm4"
            lazy-validation
          >
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <h3>Projektdaten</h3>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="formData.projekt_name"
                    :rules="validation.step4.rulesProjectName"
                    required
                  >
                    <template #label>
                      Projektname<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="formData.projekt_strasse"
                    :rules="validation.step4.rulesProjectStreet"
                    required
                  >
                    <template #label>
                      Straße<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" md="2" lg="1">
                  <v-text-field
                    v-model="formData.projekt_plz"
                    maxlength="5"
                    :rules="validation.step4.rulesProjectPLZ"
                    required
                  >
                    <template #label>
                      PLZ<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="8" md="5" lg="6">
                  <v-text-field
                    v-model="formData.projekt_ort"
                    :rules="validation.step4.rulesProjectOrt"
                    required
                  >
                    <template #label>
                      Ort<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="5" lg="5">
                  <v-text-field
                    v-model="formData.projekt_land"
                    :rules="validation.step4.rulesProjectLand"
                    required
                  >
                    <template #label>
                      Land<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <h3>Kundendaten</h3>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="formData.firma"
                    :rules="validation.step4.rulesCompany"
                    required
                  >
                    <template #label>
                      Firma<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="formData.ansprechpartner"
                    :rules="validation.step4.rulesContactPerson"
                    required
                  >
                    <template #label>
                      Ansprechpartner<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="formData.strasse"
                    :rules="validation.step4.rulesStreet"
                    required
                  >
                    <template #label>
                      Straße<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="formData.telefon"
                    :rules="validation.step4.rulesPhone"
                    required
                  >
                    <template #label>
                      Telefon<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" md="2" lg="1">
                  <v-text-field
                    v-model="formData.plz"
                    maxlength="5"
                    :rules="validation.step4.rulesPLZ"
                    required
                  >
                    <template #label>
                      PLZ<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="8" md="4" lg="5">
                  <v-text-field
                    v-model="formData.ort"
                    :rules="validation.step4.rulesOrt"
                    required
                    label="Ort"
                  >
                    <template #label>
                      Ort<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    v-model="formData.email"
                    :rules="validation.step4.rulesEmail"
                    required
                  >
                    <template #label>
                      E-Mail-Adresse<strong> *</strong>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <h3>Rechnungsadresse</h3>
                </v-col>
                <v-col cols="12">
                  Bitte nur ausfüllen, wenn die Rechnungsadresse von den Kundendaten abweicht.
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="formData.rechnung_firma"
                  >
                    <template #label>
                      Firma
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="formData.rechnung_kontakt"
                  >
                    <template #label>
                      Ansprechpartner
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="formData.rechnung_strasse"
                  >
                    <template #label>
                      Straße
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="formData.rechnung_telefon"
                  >
                    <template #label>
                      Telefon
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" md="2" lg="1">
                  <v-text-field
                    v-model="formData.rechnung_plz"
                    maxlength="5"
                  >
                    <template #label>
                      PLZ
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="8" md="4" lg="5">
                  <v-text-field
                    v-model="formData.rechnung_stadt"
                    label="Ort"
                  >
                    <template #label>
                      Ort
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    v-model="formData.rechnung_email"
                  >
                    <template #label>
                      E-Mail-Adresse
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <h3>
                    <b>Wünschen Sie einen Vor-Ort-Termin ? </b>
                    <v-tooltip
                      right
                      max-width="400"
                      open-on-click
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          dark
                          dense
                          middle
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        In diesem Termin nehmen wir die Gegebenheiten in Augenschein und geben Ihnen Hinweise, wie die Umsetzung des Schutzkonzeptes erfolgen kann.
                      </span>
                    </v-tooltip>
                  </h3>
                  <v-radio-group
                    v-model="formData.vor_ort_termin"
                  >
                    <v-radio
                      label="Ja"
                      value="TRUE"
                    ></v-radio>
                    <v-radio
                      label="Nein"
                      value="FALSE"
                    ></v-radio>
                  </v-radio-group>
                  <p class="mb-0">
                    Bei Fragen melden Sie sich gerne:<br />
                    <a href="mailto:dehnconcept@dehn.de">dehnconcept@dehn.de</a><br />
                    Tel. +49 9181 906-1600
                  </p>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="formData.angebot"
                    label="Ich willige ein, dass mir auf Basis meiner zur Verfügung gestellten Daten ein kostenfreies / unverbindliches Angebot zugesendet wird."
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="formData.datenschutz"
                    :rules="validation.step4.rulesPrivacy"
                    required
                    hide-details="auto"
                  >
                    <template #label>
                      Datenschutzerklärung gelesen und anerkannt <strong class="pl-2">*</strong>
                    </template>
                  </v-checkbox>
                  <small>
                    Ich stimme der Verarbeitung meiner personenbezogenen Daten gemäß der Datenschutzerklärung zu.
                    Hier geht's zur <a href="https://www.dehn.de/de/datenschutzerklaerung"
                                       target="_blank" style="text-decoration: underline">Datenschutzerklärung.</a>
                  </small>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="formData.kontakt"
                    label="Ja, ich stimme einer Kontaktaufnahme zu und möchte weitere Infos erhalten."
                    hide-details
                  ></v-checkbox>
                  <small>
                    Ich bin damit einverstanden, dass meine Daten durch die DEHN SE elektronisch zu Zwecken
                    der Werbung und Marktforschung verarbeitet werden. Ich kann die vorstehende Einwilligung
                    jederzeit ohne Angabe von Gründen durch schriftliche Erklärung - auch per e-Mail an
                    <a href="mailto:revoke@dehn.de" style="text-decoration: underline">revoke@dehn.de</a> - gegenüber der DEHN SE, Hans-Dehn-Straße 1, 92318 Neumarkt widerrufen.
                  </small>
                </v-col>
                <v-col cols="12">
                  <small>Die mit * markierten Felder sind Pflichtfelder.</small>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-stepper-content>
        <v-row class="mt-6">
          <v-col cols="6" sm="4" order="2" order-sm="1">
            <v-btn
              v-if="currentStep != 0"
              color="secondary"
              depressed
              v-on:click="nextStep(parseInt(currentStep) - 1)"
            >Zurück</v-btn>
          </v-col>
          <v-col cols="12" sm="4" order="1" order-sm="2" class="text-center">
            <v-btn
              v-if="currentStep != 0"
              @click="reset"
              :block="$vuetify.breakpoint.xsOnly"
              color="secondary"
              outlined
              depressed
            >Alles zurücksetzen</v-btn>
          </v-col>
          <v-col cols="6" sm="4" order="3" order-sm="3" class="text-right">
            <v-btn
              v-if="currentStep != steps"
              color="primary"
              v-on:click="nextStep(parseInt(currentStep) + 1)"
            >Weiter</v-btn>
            <v-btn
              v-if="currentStep == steps"
              :loading="submitStatus"
              :disabled="submitStatus"
              elevation="5"
              @click="submitForm"
              :block="$vuetify.breakpoint.xsOnly"
              color="primary"
            >Abschicken</v-btn>
          </v-col>
        </v-row>
      </v-stepper-items>

    </v-stepper>
  </div>


</template>

<script>
import UploadFiles from "./UploadFiles";
import TooltipBlitzschutzkonzept from "./tooltips/TooltipBlitzschutzkonzept";
import {DCFORMSERVICE, dataLayer} from "../http-common";
import TooltipErdungskonzeptBlitzschutzsysteme from "./tooltips/TooltipErdungskonzeptBlitzschutzsysteme";
import TooltipUeberspannungsschutzkonzept from "./tooltips/TooltipUeberspannungsschutzkonzept";
import TooltipBudgetplanung from "./tooltips/TooltipBudgetplanung";
import TooltipPlanungsabschlussgespraech from "./tooltips/TooltipPlanungsabschlussgespraech";
import TooltipRisikoanalyse from "./tooltips/TooltipRisikoanalyse";
import TooltipTrennungsabstandsberechnung from "./tooltips/TooltipTrennungsabstandsberechnung";
import Tooltip3DLaserscanning from "./tooltips/Tooltip3DLaserscanning";
import TooltipZeichnungserstellung from "./tooltips/TooltipZeichnungserstellung";
import TooltipSchutzraum from "./tooltips/TooltipSchutzraum";
import TooltipAbnahmeBlitzschutz from "./tooltips/TooltipAbnahmeBlitzschutz";
import TooltipDimensionierungErdungsanlage from "./tooltips/TooltipDimensionierungErdungsanlage";
import TooltipQuerschnittsberechnung from "./tooltips/TooltipQuerschnittsberechnung";
import TooltipErdungssimulationBlitzTrafo from "./tooltips/TooltipErdungssimulationBlitzTrafo";
import TooltipErdungssimulationenKurzschluss from "./tooltips/TooltipErdungssimulationenKurzschluss";

export default {
  name: "Stepper.vue",

  components: {
    TooltipErdungssimulationenKurzschluss,
    TooltipErdungssimulationBlitzTrafo,
    TooltipQuerschnittsberechnung,
    TooltipDimensionierungErdungsanlage,
    TooltipAbnahmeBlitzschutz,
    TooltipSchutzraum,
    TooltipZeichnungserstellung,
    Tooltip3DLaserscanning,
    TooltipTrennungsabstandsberechnung,
    TooltipRisikoanalyse,
    TooltipPlanungsabschlussgespraech,
    TooltipBudgetplanung,
    TooltipUeberspannungsschutzkonzept,
    TooltipErdungskonzeptBlitzschutzsysteme,
    UploadFiles,
    TooltipBlitzschutzkonzept
  },

  props: {
    userRoles: {
      required: true,
      type: Array
    }
  },

  data: () => ({
    errors: [],
    loadingStatus: false,
    submitStatus: false,
    localStorageVersion: 5,
    project: {
      id: '',
      code: '',
    },
    currentStep: 0,
    steps: 4,
    valid: false,
    showThanks: false,
    dialogBoen: false,
    dialogWindzone: false,
    validation: {
      step2: {
        valid: true,
        rulesProjectName: [
          v => !!v || 'Erforderlich'
        ],
      },
      step4: {
        valid: true,
        rulesCompany: [
          v => !!v || 'Erforderlich'
        ],
        rulesContactPerson: [
          v => !!v || 'Erforderlich'
        ],
        rulesEmail: [
          v => !!v || 'Erforderlich',
          v => /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(v.toLowerCase())) || 'E-mail ist ungültig',
        ],
        rulesProjectName: [
          v => !!v || 'Erforderlich'
        ],
        rulesProjectStreet: [
          v => !!v || 'Erforderlich'
        ],
        rulesProjectPLZ: [
          v => !!v || 'Erforderlich'
        ],
        rulesProjectOrt: [
          v => !!v || 'Erforderlich'
        ],
        rulesProjectLand: [
          v => !!v || 'Erforderlich'
        ],
        rulesPhone: [
          v => !!v || 'Erforderlich'
        ],
        rulesStreet: [
          v => !!v || 'Erforderlich'
        ],
        rulesPLZ: [
          v => !!v || 'Erforderlich'
        ],
        rulesOrt: [
          v => !!v || 'Erforderlich'
        ],
        rulesPrivacy: [
          v => v > 0 || 'Erforderlich'
        ],
      },
    },
    formData: {
      firma: '',
      ansprechpartner: '',
      strasse: '',
      telefon: '',
      plz: '',
      ort: '',
      email: '',
      rechnung_firma: '',
      rechnung_kontakt: '',
      rechnung_strasse: '',
      rechnung_plz: '',
      rechnung_stadt: '',
      rechnung_telefon: '',
      rechnung_email: '',
      projekt_name : '',
      projekt_strasse: '',
      projekt_plz: '',
      projekt_ort: '',
      projekt_land: '',
      vor_ort_termin: '',
      gebauede_branche: [],
      gebauede_branche_andere: '',
      gebauede_infos: '',
      gebauede_ortgegeb_gebauedehoehe: '',
      gebauede_ortgegeb_gebauedlage: '',
      gebauede_ortgegeb_boengeschwindigkeit: '',
      gebauede_ortgegeb_windzone: '',
      gebauede_ortgegeb_gelaendekategorie: '',
      gebauede_struktur_art: [],
      gebauede_struktur_bedachung: [],
      gebauede_struktur_konstruktion: [],
      gebauede_struktur_fassade: [],
      gebauede_struktur_ausfuehrung_dach: '',
      gebauede_ex_zonen: '',
      gebauede_blitzschutzklasse: '',
      planung_aussen_innen_blitzschutz: [],
      planung_erdung_blitzschutz: [],
      planung_trafostationen: [],
      planung_sonstiges: [],
      angaben_ueberspannungsschutz_netzsystem: '',
      angaben_ueberspannungsschutz_einspeisesicherung: '',
      angaben_ueberspannungsschutz_energietechnische_anlage: [],
      angaben_ueberspannungsschutz_sonstiges_anlagen: '',
      angaben_ueberspannungsschutz_informationstechnische_anlagen: [],
      angaben_ueberspannungsschutz_sonstige_msr: '',
      angaben_erdung_erdungsangaben: '',
      angaben_erdung_erdfuehligkeit : '',
      angaben_risiko_max_person_anzahl: '',
      angaben_risiko_max_person_stunden: '',
      angaben_risiko_versorgungsleitungen: '',
      angaben_risiko_brandlast: '',
      angaben_risiko_freistehend: '',
      angaben_3dmodell: '',
      angaben_budget_getrenntes_blitzschutzsystem: [],
      angaben_budget_konventionelles_blitzschutzsystem: [],
      angaben_blitzschutz_getrenntes_blitzschutzsystem: [],
      angaben_blitzschutz_konventionelles_blitzschutzsystem: [],
      datenschutz: false,
      angebot: false,
      kontakt: false,
      upload_nda: ''
    },
    selectData: {
      gebauede_branche: [
        { name: 'Handwerk', id: 'HANDWERK' },
        { name: 'Großhandel und Einkaufsgenossenschaften', id: 'GROSSHANDEL' },
        { name: 'Bauindustrie', id: 'BAUINDUSTRIE' },
        { name: 'Versorgungsbetriebe/Entsorgungsbetriebe', id: 'VERSORGUNG' },
        { name: 'Industrie', id: 'INDUSTRIE' },
        { name: 'Behörden/Staatsunternehmen/Teilpriv. Unternehmen', id: 'BEHOERDEN' },
        { name: 'Berater, Planer, Ausbildungsstätten, Techn. Aufsichtsgremien', id: 'BERATER' },
        { name: 'Sonstiges', id: 'SONSTIGES' }
      ],
    },
    onlyEarthingStuffSelected: false
  }),

  watch: {
    steps (val) {
      if (this.currentStep > val) {
        this.currentStep = val
      }
    },
    formData: {
      handler() {
        localStorage.setItem('dcformData', JSON.stringify(this.formData));

        let earthingStuffSelected = false;

        if (
          this.formData.planung_aussen_innen_blitzschutz.includes('BUDGETPLANUNG') ||
          this.formData.planung_erdung_blitzschutz.length ||
          this.formData.planung_trafostationen.length
          )
          {
            earthingStuffSelected = true;
          }

        if (earthingStuffSelected
          && this.formData.planung_sonstiges.length === 0
          && (
            this.formData.planung_aussen_innen_blitzschutz.length === 0 ||
            (this.formData.planung_aussen_innen_blitzschutz.length === 1 && this.formData.planung_aussen_innen_blitzschutz.includes('BUDGETPLANUNG') ) )
        ) {
          this.onlyEarthingStuffSelected = true;
        } else {
          this.onlyEarthingStuffSelected = false;
        }

        },
      deep: true,
    },
    currentStep: {
      handler() {
        localStorage.setItem('dcformStep', JSON.stringify(this.currentStep));
        this.trackStep();
      }
    },
    project: {
      handler() {
        localStorage.setItem('dcformProject', JSON.stringify(this.project));
      },
      deep: true,
    },
  },
  methods: {
    reset () {
      Object.assign(this.$data, this.$options.data.call(this));
      this.cleanLocalStorage();
      this.fetchProject();
    },
    fetchProject() {
      if (!localStorage.getItem('dcformProject')) {
        this.loadingStatus = true;
        DCFORMSERVICE.get( 'project/create' )
          .then(response => {
            this.project.id = response.data['id']
            this.project.code = response.data['code']
            this.loadingStatus = false;
          })
          .catch(e => {
            this.errors.push(e)
          })
      } else {
        this.project = JSON.parse(localStorage.getItem('dcformProject'))
      }
    },
    cleanLocalStorage() {
      localStorage.removeItem('dcformProject');
      localStorage.removeItem('dcformData');
      localStorage.removeItem('dcformStep');
      localStorage.removeItem('dcformVersion');
      localStorage.removeItem('dcformFilesData');
    },
    nextStep (n) {

      let nextStep = parseInt(n);

      switch(parseInt(this.currentStep)) {
        case 1:
          if(!this.$refs.stepForm1.validate()) {
            nextStep = this.currentStep
            this.validation.step1.valid = false
          }
          break
        case 2:
          if(!this.$refs.stepForm2.validate()) {
            nextStep = this.currentStep
            this.validation.step2.valid = false
          }
          break
      }

      if (n > this.steps) {
        this.currentStep = 1
      } else {
        this.currentStep = nextStep
      }

    },
    trackStep() {
      dataLayer.push({
        'event': 'form_project',
        'view_config': 'Schritt ' + this.currentStep,
      });
    },
    validateAllForms() {
      let ok = true;
      if (!this.$refs.stepForm1.validate()) ok = false;
      if (!this.$refs.stepForm4.validate()) ok = false;
      return ok;
    },
    submitForm(){
      if (this.validateAllForms())
      {
        this.submitStatus = true;
        let postData = this.formData;
        postData.id = this.project.id;
        postData.code = this.project.code;
        DCFORMSERVICE.post('project/update', postData)
          .then(() => {
            //Perform Success Action
            this.submitStatus = false;
            this.showThanks = true;
            this.trackSubmit();
            this.cleanLocalStorage();
          })
          .catch((error) => {
            console.log(error);
            this.errors.push(error);
            // error.response.status Check status code
          }).finally(() => {
          //Perform action in always
        });
      } else {
        //this.errors.push('bla');
      }

    },
    trackSubmit() {
      dataLayer.push({
        'event': 'form_project',
        'view_config': 'submit',
      });
    },
  },
  created() {
    this.fetchProject();
  },
  mounted() {
    if (localStorage.getItem('dcformVersion')) {
      let oldVersion = JSON.parse(localStorage.getItem('dcformVersion'))
      if (oldVersion !== this.localStorageVersion) {
        this.cleanLocalStorage();
      }
    }
    localStorage.setItem('dcformVersion', JSON.stringify(this.localStorageVersion));
    if (localStorage.getItem('dcformData')) this.formData = JSON.parse(localStorage.getItem('dcformData'));
    if (localStorage.getItem('dcformStep')) this.currentStep = JSON.parse(localStorage.getItem('dcformStep'));
    if (this.currentStep === 0) {
      this.trackStep();
    }
  },

}
</script>

<style lang="scss">

@import '../../src/sass/variables.scss';

.v-btn:not(.v-btn--outlined).primary {
  color: $c-dehn-red !important;
}

.v-btn--outlined {
  border-color: $c-dehn-white !important;
  .v-btn__content {
    color: $c-dehn-white !important;
  }
}

.theme--dark.v-text-field:not(.v-file-input) .v-label:not(.v-label--active):not(.primary--text),
.theme--dark.v-input textarea,
.theme--dark.v-input input {
  color: $c-dehn-gray--darker !important;
}

.theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(255, 255, 255, 0.9) !important;
}

.dehn--module--text-only-and-or-headline__h1 .text * {
  color: $c-dehn-white !important;
}

.theme--dark.v-stepper .v-stepper__step--editable:hover {
  background: rgba($c-dehn-white, .12) !important;
}

.v-stepper__content h2 {
  border-bottom: 1px dotted #ffffff8c;
  padding-bottom: 0.5rem;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgba(255, 255, 255, 0.8) !important;
  .v-btn__loader {
    color: $c-dehn-red;
  }
}

.angaben {
  margin-bottom: 1rem;
  border: 4px solid white;
}

.dc_form-wrapper .theme--dark.v-list {
  background: rgba(255,255,255,0.95) !important;
  color: #000000  !important;
}

.dc_form-wrapper .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled)
{
  color: #000000  !important;
}

.dc_form-wrapper .theme--dark.v-list-item.v-list-item--active {
  background-color: $c-dehn-red;
}

.v-menu__content.theme--dark {
  scrollbar-color: $c-dehn-red white;
}

.theme--dark.v-card > .v-card__text, .theme--dark.v-card .v-card__subtitle {
  color: $c-dehn-text  !important;
}

.v-tooltip__content.menuable__content__active {
  opacity: 1!important;
}

.dehn--tooltip-html {
  padding:1rem 0.5rem 0.5rem 0.5rem;
  ul
  {
    margin: 0;
  }
}

.step1 .v-input--is-label-active {
  label {
    font-weight: bold;
  }
}

.dehn--leistung-html {
  font-size: 90%;
  display: block;
  margin-top:1rem;
  padding:1rem 0.5rem 0.2rem 0.5rem;
  background-color: rgb(249, 248, 246);
  color: rgb(91, 91, 93);
  ul
  {
    margin: 0;
  }
}


</style>
